/**
 * "Send payment-method setup email" — staff-only endpoints on a membership.
 *
 *   GET  /memberships/:id/payment-method-setup-email   can it be sent?
 *   POST /memberships/:id/payment-method-setup-email   send it
 *
 * Both resolve the response BODY and reject with the axios error untouched,
 * so the caller keeps the backend's own `code` and `error` text (a second
 * click answers 409 RECENTLY_SENT with a sentence staff can read).
 */
import axios from "./axiosInstance";
import config from "./config";

const BASE_URL = config.BASE_URL;

export interface SetupEmailStatus {
  has_email: boolean;
  email: string | null;
  last_sent_at: string | null;
  can_send: boolean;
  retry_after_seconds: number;
  resend_window_minutes: number;
}

export interface SetupEmailStatusResponse {
  success: boolean;
  data: SetupEmailStatus;
}

export interface SetupEmailSendResponse {
  success: boolean;
  message: string;
  data: { sent_to: string; sent_at: string };
}

const headers = (token: string | null) => ({
  "Content-Type": "application/json",
  authorization: `Bearer ${token}`,
});

export const getPaymentMethodSetupEmailStatus = async (
  token: string | null,
  membershipId: string
): Promise<SetupEmailStatusResponse> => {
  const res = await axios.get(`${BASE_URL}/memberships/${membershipId}/payment-method-setup-email`, {
    headers: headers(token),
  });
  return res.data;
};

export const sendPaymentMethodSetupEmail = async (
  token: string | null,
  membershipId: string
): Promise<SetupEmailSendResponse> => {
  const res = await axios.post(
    `${BASE_URL}/memberships/${membershipId}/payment-method-setup-email`,
    {},
    { headers: headers(token) }
  );
  return res.data;
};
